import { Outlet } from 'react-router-dom';

import { Box, H5 } from '@parspec/pixel';

import { AddEditLocContextProvider } from './context';
import { NavTabs } from './NavTabs';

export const AddEditLocation = () => {

    return (
        <>
            <AddEditLocContextProvider>
                <Box display="flex" flexDirection="column" py={4} overflow="hidden" bgcolor="primary.contrastText" width="calc(100vw - 390px)">
                    <Box>
                        <Box p={6}>
                            <H5 width={'max-content'}>Branch Locations</H5>
                        </Box>
                        <Box display="flex" flexDirection="column" minHeight={0} borderBottom="1px solid" borderColor="neutral.main" px={4}>
                            <NavTabs />
                        </Box>
                    </Box>
                    <Box overflow="auto" p={6}>
                        <Outlet />
                    </Box>
                </Box>
            </AddEditLocContextProvider>
        </>
    );
};
